/**
 * Hook to scroll to a section on page load (useful for navigation from other pages)
 */

import { useEffect } from 'react';

export function useScrollOnLoad() {
  useEffect(() => {
    // Check if there's a stored scroll target
    const scrollToSection = localStorage.getItem('scrollToSection');
    if (scrollToSection) {
      // Clear the stored value
      localStorage.removeItem('scrollToSection');

      // Wait for page to fully load, then scroll
      setTimeout(() => {
        const element = document.getElementById(scrollToSection);
        if (element) {
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - navbarHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }

    // Also check for hash in URL
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.getElementById(window.location.hash.slice(1));
        if (element) {
          const navbarHeight = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - navbarHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);
}
